import React, { useState, useEffect, useRef  } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [name, setName] = useState("")

  const [address, setAddress] = useState("")

  const [telephone, setTelephone] = useState("")

  const [email, setEmail] = useState("")

  const [status, setStatus] = useState("active")

  const [createdAt, setCreatedAt] = useState(new Date())

  

  const [errorName, setErrorName] = useState(false)

  const [errorAddress, setErrorAddress] = useState(false)

  const [errorTelephone, setErrorTelephone] = useState(false)

  const [errorEmail, setErrorEmail] = useState(false)

  
  const navigate = useNavigate();


  
    
    const handleRewards = async(e) => {
  
      e.preventDefault()

      if(name === ""){
        
        return setErrorName("Name is required")
      }

       if(address === ""){
        
        return setErrorAddress("Address is required")
      }

       if(telephone === ""){
        
        return setErrorTelephone("Telephone is required")
      }

       if(email === ""){
        
        return setErrorEmail("Email is required")
      }
      
      setIsloading(true)
  
      try{
           
         const advertResponse = await addDoc(collection(db, "rewardlocation"), {
        
          name: name,
          address: address,
          telephone: telephone,
          email: email,
          status: status,
          createdAt : today,
          
        });

        navigate("/rewardlocation")
        
      }catch (err) {

        console.log(err);

      } 
  
    }

    const handleName = (e) => {

         setName(e.target.value)

         if(name !== ""){

          setErrorName(false)
          
         }

    }

    
    const handleAddress = (e) => {

         setAddress(e.target.value)

         if(address !== ""){

          setErrorAddress(false)
          
         }

    }


      const handleTelephone = (e) => {


          setTelephone(e.target.value)

         if(telephone !== ""){

          setErrorTelephone(false)
          
         }

    }


    const handleEmail = (e) => {

         setEmail(e.target.value)

         if(email !== ""){

          setErrorEmail(false)
          
         }

    }




  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Reward Location</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/rewardlocation"
            >
              Reward Location List
            </Link>
            <Typography color="green">New Reward Location</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>


                    <div style={{width:'49%', flexDirection:'column'}}>

                       <TextField
                            type="text"
                            name="title"
                            placeholder="Enter location eg Chicken Republic, Ikeja"
                            value={name}
                            onChange={handleName}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                          />
                          {
                            errorName &&

                            <p style={{color:'red', fontSize:15, }}>{errorName}</p>

                          }

                    </div>

                    <div style={{width:'49%', flexDirection:'column'}}>

                       <TextField
                            type="text"
                            name="address"
                            placeholder="Enter Location Address"
                            value={address}
                            onChange={handleAddress}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                          />
                          {
                            errorAddress &&

                            <p style={{color:'red', fontSize:15, }}>{errorAddress}</p>

                          }

                    </div>

                      <div style={{width:'49%', flexDirection:'column'}}>

                       <TextField
                            type="text"
                            name="telephone"
                            placeholder="Enter Location Telephone"
                            value={telephone}
                            onChange={handleTelephone}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                          />
                          {
                            errorTelephone &&

                            <p style={{color:'red', fontSize:15, }}>{errorTelephone}</p>

                          }

                    </div>


                       <div style={{width:'49%', flexDirection:'column'}}>

                       <TextField
                            type="text"
                            name="email"
                            placeholder="Enter Location Email"
                            value={email}
                            onChange={handleEmail}
                            style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
                            variant="outlined" 
                            sx={{ "& fieldset": { border: "none" } }} 
                          />
                          {
                            errorEmail &&

                            <p style={{color:'red', fontSize:15, }}>{errorEmail}</p>

                          }

                    </div>

                
                
                </div>


                <hr style={{width:'100%', height:0, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handleRewards} 
                    disabled={isloading}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...loading' : 'Upload Location '}
                    
                  </Button>


               


          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New
